import React, { useContext, useEffect, useRef, useState } from "react";
import Card from "../../Components/Card/Card";
import { Button } from "primereact/button";
import { getCurrencyIPS } from "../../API/Global/Currency/CurrencyRequest";
import {
  CambiarEstado,
  CambiarEstadoRevision,
  CambiarEstadoRevisionIT,
  getArchivoProveedor,
  getCompanyCompras,
  getCompanyVarios,
  getEnlaceInscripcion,
  postCategoriaProveedor,
  updateEnlaceInscripcion,
} from "../../../Base/API/Proveedores/ProveedoresRequest";
import AgGrid from "../../Components/Tables/AgGrid/AgGrid";
import { Toast } from "primereact/toast";
import { downloadBase64Data } from "../../Services/ArchivosService";
import { formatCodigoProveedor } from "../../Services/Format";
import { Checkbox } from "primereact/checkbox";
import { SplitButton } from "primereact/splitbutton";
import { toastShow } from "../../Services/ToastService";
import { getCorreos } from "../../../Base/API/IT/ListaCorreos/ListaCorreosRequest";
import Loading from "../../../Base/Components/Loader/Loader";
import ModalProveedorCAI from "./ProveedoresCAI/ModalProveedorCAI";
import ModalProveedores from "./ModalProveedores";
import ModalSolicitudEdicionProveedor from './SolicitudesEdicionProveedores/ModalSolicitudesEdicionProveedores';
import { getEstadosCategoryIPS, getEstadosClientesIPS } from "../../API/Global/Estados/StatusRequest";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import ReusableDialog from "../../Components/Dialog/ReusableDialog";
import { sendEmail } from "../../Services/Email/EmailRequest";
import FormatoInscripcionPDF from "./FormatoInscripcionPDF";
import { getCountriesList, getCountryList } from "../../API/Countries/CountriesRequest";
import { jwtDecode } from "jwt-decode";
import { Dialog } from "primereact/dialog";
import { Password } from "primereact/password";
import { encryptor } from "../../Services/Crypto/Crypto";

const ProveedoresScreen = ({ IsVarios = false, Finanzas = false }) => {
  const toast = useRef(null);

  const [Proveedores, setProveedores] = useState([]);
  const [proveedoresFilter, setProveedoresFilter] = useState([])
  // const [loadingCorreo, setLoadingCorreo] = useState(false);
  const [enlace, setEnlace] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proveedorMail, setProveedorMail] = useState({});
  const [idioma, setIdioma] = useState("es");
  const [correoAEviar, setCorreoAEviar] = useState([]);
  const [IdCustomer, setIdCustomer] = useState(0);
  const [dialogCAI, setDialogCAI] = useState(false);
  const [proveedoresDialog, setProveedoresDialog] = useState(false);
  const [dialogSolicitudEdicion, setDialogSolicitudEdicion] = useState(false);
  const [proveedorSolicitudEdicion, setProveedorSolicitudEdicion] = useState(null); 
  const [estados, setEstados] = useState([]);
  const [estadosRevision, setEstadosRevision] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialogFormato, setShowDialogFormato] = useState(false);
  const [selectedFormato, setSelectedFormato] = useState(null);
  const [lenguaje, setLenguaje] = useState('es');
  const { userAuth } = useContext(AuthContext);

  const [showDialogPassword, setShowDialogPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [proveedorEditar, setProveedorEditar] = useState(null);

  const [mostarActivos, setMostarActivos] = useState(true);



  const openNew = (Id) => {
    setIdCustomer(Id);
    setProveedoresDialog(true);
  };

  const openDialogCAI = (Id) => {
    setIdCustomer(Id);
    setDialogCAI(true);
  };

  const openDialogSolicitudEdicion = (rowData) => {
    setIdCustomer(rowData.IdCustomer);
    setProveedorSolicitudEdicion(rowData);
    setDialogSolicitudEdicion(true);
  };

  const hideDialog = () => {
    setProveedoresDialog(false);
    setDialogCAI(false);
    // obtenerProveedores()
  };
  
  const botonEnviarCorreo = (data) => {
    if (data?.IdCustomer) {
      let habilitar = validarDeshabilitarEdicion(data);
      const items = [
        {
          label: "Ingles",
          command: async () => {
            setShowDialogFormato(true)
            setSelectedFormato(data)
            setLenguaje('en')
          },
        },
        {
          label: "Español",
          command: async () => {
            setShowDialogFormato(true)
            setSelectedFormato(data)
          },
        },
      ];
      return (
        <div className="d-flex gap" style={{ textAlign: "center", height: 28 }}>
          {/* <Checkbox
            className="mt-1"
            checked={data.esEditable && !validarDeshabilitarEdicion(data)}
            onChange={(e) => ChangeEstadoEdicion(data.IdCustomer, e.checked)}
            disabled={habilitar}
          /> */}
          {/* IMPRIMIR */}
          <SplitButton
            className="p-button-text"
            icon="pi pi-print"
            tooltip="Imprimir"
            tooltipOptions={{ position: "left" }}
            onClick={async () => {
              setShowDialogFormato(true)
              setSelectedFormato(data)
            }}
            model={items}
            style={{ padding: "0" }}
          />
        </div>
      );
    } else {
      return null;
    }
  };


  const validarDeshabilitarEdicion = (data) => {
    const estadosHabilitadoEdicion = [3722]
    // let usuaroTieneAcceso = userAuth.AccesosWeb.split(',').includes('1030');
    // console.log(estadosHabilitadoEdicion.findIndex(e => e === data.IdStatusRevision) < 0, !usuaroTieneAcceso);
    return estadosHabilitadoEdicion.findIndex(e => e === data.IdStatusRevision) < 0
    // && !usuaroTieneAcceso
  }

  const botonDonwload = (File, tooltip, IdCustomer, FileName) => {
    if (IdCustomer) {
      return (
        <div
          className="col-12 d-flex align-items-center"
          style={{ textAlign: "center" }}
        >
          <Button
            className="p-button-outlined p-button-text mx-3"
            icon="pi pi-download"
            tooltip={tooltip}
            tooltipOptions={{ position: "left" }}
            disabled={FileName === null}
            onClick={() => {
              getFile(File, IdCustomer);
            }}
            style={{ padding: "0" }}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const getFile = async (file, IdCustomer) => {
    const File = await getArchivoProveedor(file, IdCustomer);
    if (File.length > 0) {
      downloadBase64Data({ Data: File[0]?.Archivo, Tipo: File[0]?.Name });
    }
  };

  const ChangeEstadoEdicion = (IdCustomer, Estado) => {
    updateEnlaceInscripcion({ IdCustomer, Estado });
    const tempo = Proveedores.map((item) => {
      if (item.IdCustomer === IdCustomer) {
        item.esEditable = Estado;
        toastShow(
          toast,
          "success",
          "Se actualizó el estado de edición del enlace de inscripción del proveedor"
        );
      }
      return item;
    });
    setProveedores(tempo);
  };

  const EnviarCorreoInscripcion = async () => {
    // setLoadingCorreo(true);
    if (enlace?.enlace) {
      const decoded = jwtDecode(enlace?.enlace);
      const idCustomer = decoded.IdCustomer;
      const obtenerProveedor = Proveedores.filter(e => e.IdCustomer === idCustomer);
      const idCountry = obtenerProveedor[0]?.IdCountry;

      const correos = await getCorreos(1);

      let contenidoEs = ` <div>
            <p>Estimado Proveedor: ${proveedorMail?.CustomerName}</p>

            <p>Apreciamos su comunicación y creemos sin duda que ésta será la clave para comenzar y mantener una excelente relación comercial entre ambas compañías, su colaboración lo convertirá en un importante aliado para nuestros procesos presentes y futuros.</p>

            <p>El enlace que a continuación se le comparte lo dirigirá hacia un formulario de inscripción de nuevos proveedores, por favor complete toda la información que allí se le solicita.  </p>
            
            <a href=${process.env.REACT_APP_PUBLIC_URL}/inscripcionProveedor/${idioma}/${enlace?.enlace} target='_blank' rel="noreferrer" >Has click aquí para ingresar al formulario.</a>

            <p>Para cualquier consulta, puede contactarnos al número +504 2625-4400.</p>

            <p>*Un formulario incompleto hará que nuestro proceso de pago o compras se retrase.</p>
            <p>*Correo generado automáticamente, por favor no responder.</p>


            <p>Saludos cordiales.</p>
            <br />

      </div>`

      let contenidoEn = `<div>
          <p>Dear Supplier: ${proveedorMail?.CustomerName}</p>

          <p>We appreciate your communication and firmly believe that it will be the key to starting and maintaining an excellent business relationship between both companies. Your collaboration will make you an important ally for our present and future processes.</p>

          <p>The link below will direct you to a new supplier registration form. Please complete all the requested information.</p>

          <a href={${process.env.REACT_APP_PUBLIC_URL}/inscripcionProveedor/${idioma}/${enlace?.enlace}} target='_blank' rel="noreferrer">Click here to access the form.</a>

          <p>For any inquiries, you can contact us at +504 2625-4400.</p>

          <p>*An incomplete form will delay our payment or purchasing process.</p>
          <p>*This email was generated automatically, please do not reply.</p>

          <p>Best regards.</p>
          <br /> 
      </div>`;

      const objeto = {
        to: correoAEviar.toString(),
        cc: correos[0].CCMail + ',' + userAuth?.Mail,
        bcc: correos[0].CCoMail,
        // to: 'clopez@ppf.com.hn',
        subject: idioma === 'es' ? `Inscripción y actualización de información de proveedor` : 'Registration and updating supplier information',
        texto: idioma === 'es' ? contenidoEs : contenidoEn,
      };

      //Agregar los archivos solo si el proveedor tiene IdCountry = 95 (Honduras)
      if (idCountry === 95) {
        objeto.attachments = [
          {
            filename: 'Requisitos Bancarios Proveedores.pdf',
            path: `${process.env.REACT_APP_PUBLIC_URL}/files/RequisitosBancariosProveedores.pdf`,
          },
          {
            filename: 'Requisitos Presentación Facturas.pdf',
            path: `${process.env.REACT_APP_PUBLIC_URL}/files/RequisitosPresentacionFacturas.pdf`,
          }
        ];
      }


      const result = await sendEmail(objeto);
      if (result) {
        toastShow(toast, "success", "Correo enviado exitosamente.");
      } else {
        toastShow(toast, "error", "Correo no enviado.");
      }

      setTimeout(async () => {
        setProveedorMail(undefined);
        // setLoadingCorreo(false);
        setShowDialog(false);
      }, 1000);
    }
  };

  const changeEstado = ({ data, api }) => {
    return <div>
      <Dropdown
        value={estados.filter(e => e.IdStatus === data.IdEstado)[0]}
        options={estados}
        optionLabel="StatusName"
        filter
        // disabled={[2, 3].includes(data?.IdStatus)}
        filterBy="StatusName"
        style={{ width: '100%' }}
        onChange={(e) => {
          confirmDialog({
            message: `¿Cambiar a estado ${e.value.StatusName} al Proveedor ${data.CustomerName}?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
              const index = Proveedores.findIndex(detail => detail.IdCustomer === data.IdCustomer);
              let newDetail = [...Proveedores];
              newDetail[index].IdStatus = e.value.IdStatus;
              newDetail[index].StatusName = e.value.StatusName;
              CambiarEstado(e.value.IdStatus, data.IdCustomer)
              setProveedores(newDetail);
              getInfo();
              api.stopEditing();
            },
            reject: () => {
              getInfo();
            }
          })
        }}
      />
    </div>
  }

  const changeEstadoRevision = ({ data, api }) => {
    return <div>
      <Dropdown
        value={estadosRevision.filter(e => e.IdStatus === data.IdEstado)[0]}
        options={estadosRevision}
        optionLabel="StatusName"
        filter
        filterBy="StatusName"
        style={{ width: '100%' }}
        // disabled={data.IdStatusRevision === 3724}
        onChange={(e) => {
          confirmDialog({
            message: `¿Cambiar a estado ${e.value.StatusName} al Proveedor ${data.CustomerName}?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
              const index = Proveedores.findIndex(detail => detail.IdCustomer === data.IdCustomer);
              let newDetail = [...Proveedores];
              newDetail[index].IdStatus = e.value.IdStatus;
              newDetail[index].StatusName = e.value.StatusName;
              CambiarEstadoRevisionIT({ IdStatus: e.value.IdStatus, IdCustomer: data.IdCustomer, IdUser: userAuth?.idUser })
              setProveedores(newDetail);
              getInfo();
              api.stopEditing();
            },
            reject: () => {
              getInfo();
            }
          })
        }}
      />
    </div>
  }



  const columnBands = [
    {
      field: "IdCustomer",
      header: "ID",
      headerEn: 'IDdd',
      className: "XXsmall",
      hidden: userAuth?.IdRol === 1,
      frozen: "frozen",
    },

    // {
    //   // Codigo
    //   field: "IdCustomer",
    //   header: "Codigo proveedor",
    //   className: "colum-width-small",
    //   body: (rowData) => formatCodigoProveedor(rowData.IdCustomer),
    //   frozen: "frozen",
    //   alignFrozen: "left",
    //   Format: "IdCustomer",
    // },
    {
      // Codigo
      field: "CodigoCompany",
      header: "Codigo proveedor",
      className: "colum-width-small",
      // body: (rowData) => formatCodigoProveedor(rowData.IdCustomer),
      frozen: "frozen",
      alignFrozen: "left",
      // Format: "IdCustomer",
    },
    {
      // CustomerName
      field: "CustomerName",
      header: "Nombre Legal",
      className: "colum-width-XXlarge",
      body: (rowData) => rowData.CustomerName,
      frozen: "frozen",
      alignFrozen: "left",
      Sumary: 'count'
    },
    {
      // CustomerName
      field: "NombreComercial",
      header: "Nombre Comercial",
      className: "colum-width-XXlarge",
      body: (rowData) => rowData.NombreComercial,
      Sumary: 'count'
    },
    {
      headerName: 'Revisión',
      children: [
        {
          field: "EstadoRevision",
          header: "Estado Revisión",
          headerEn: "Status Review",
          className: "small",
          filter: true,
          cellEditor: changeEstadoRevision,
          body: (rowData) => ({ ID: rowData.IdStatusRevision, Estado: rowData.EstadoRevision }),
          Format: "Estado",
          //  editable: userAuth?.IdRol === 1
        },
        {
          // CustomerName
          field: "UserNameReviso",
          header: "Usuario Reviso",
          className: "colum-width-large",
          body: (rowData) => rowData.UserNameReviso,
        },
        {
          field: "DateRevision",
          header: "Fecha Revisión",
          headerEn: "Date Create",
          className: "small",
          filter: true,
          Format: "Datetime",
        },
      ]
    },
    {
      field: "DateCreate",
      header: "Fecha Creado",
      headerEn: "Date Create",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      filter: true,
      cellEditor: changeEstado,
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
      Format: "Estado",
      // editable: userAuth.IdRol === 1
    },
    {
      field: 'IdStatusRevision',
      header: 'IdStatusRevision',
      headerEn: '',
      className: 'Xsmall',
      hidden: userAuth.IdRol === 1,
    },
    {
      field: 'UsuarioCreo',
      header: 'UsuarioCreo',
      headerEn: '',
      className: 'Xsmall',
      hidden: userAuth.IdRol === 1,
    },

    {
      field: 'CategoriaProveedor',
      header: 'Categoria Proveedor',
      headerEn: 'Supplier Category',
      className: 'small',
      Format: 'Center'
    },
    {
      field: "TermName",
      header: "Terminos",
      headerEn: "TermName",
      className: "Xsmall",
      Format: "Center",
    },
    {
      field: "TermValue",
      header: "TermValue",
      headerEn: "TermValue",
      className: "Xsmall",
      Format: "Center",
    },
    {
      field: "MonedaPago",
      header: "Moneda Pago",
      headerEn: "Payment Currency",
      className: "small",
      Format: "Center",
    },

    {
      headerName: "Información General",
      header: "Información General",
      children: [
        {
          // RTN
          field: "RTN",
          header: "RTN",
          className: "colum-width-medium",
          body: (rowData) => rowData.RTN,
          aling: "center",
          Sumary: "count",
        },
        {
          // CasaMatriz
          field: "CasaMatriz",
          header: "Casa Matriz",
          className: "colum-width-Xlarge",
          body: (rowData) => rowData.CasaMatriz,
        },
        {
          // Country
          field: "Country",
          header: "País",
          className: "colum-width-small",
          body: (rowData) => rowData.Country,
        },
        {
          // State
          field: "State",
          header: "Estado",
          className: "colum-width-small",
          body: (rowData) => rowData.State,
        },
        {
          // City
          field: "City",
          header: "Ciudad",
          className: "colum-width-medium",
          body: (rowData) => rowData.City,
        },
        {
          // Address
          field: "Address",
          header: "Dirección Comercial",
          className: "colum-width-XXlarge",
          body: (rowData) => rowData.Address,
        },
        {
          // DireccionCasaMatriz
          field: "DireccionCasaMatriz",
          header: "Dirección Casa Matriz",
          className: "colum-width-Xlarge",
          body: (rowData) => rowData.DireccionCasaMatriz,
        },
        {
          // Tel
          field: "Tel",
          header: "Teléfono",
          className: "colum-width-small",
          body: (rowData) => rowData.Tel,
        },
        {
          // Email
          field: "Email",
          header: "Correo",
          className: "colum-width-medium",
          body: (rowData) => rowData.Email,
        },
        {
          // PrincipalActividadEconomica
          field: "PrincipalActividadEconomica",
          header: "Principal Actividad Económica",
          className: "colum-width-Xlarge",
          body: (rowData) => rowData.PrincipalActividadEconomica,
        },
        {
          // TipoFactura
          field: "TipoFactura",
          header: "Tipo Factura",
          className: "colum-width-medium",
          body: (rowData) => rowData.TipoFactura,
        },
      ],
    },

    {
      headerName: "Representante Legal",
      children: [
        // INFROMACION DE CONTACTO REPRESENTANTE LEGAL
        {
          // NombreRepresentanteLegal
          field: "NombreRepresentanteLegal",
          header: "Nombre",
          className: "colum-width-medium",
          body: (rowData) => rowData.NombreRepresentanteLegal,
        },
        {
          // CorreoRepresentanteLegal
          field: "CorreoRepresentanteLegal",
          header: "Correo",
          className: "colum-width-",
          body: (rowData) => rowData.CorreoRepresentanteLegal,
        },
      ],
    },

    {
      headerName: "Contacto Cuentas por Cobrar",
      children: [
        {
          field: "ContactoCuentasPorCobrar",
          header: "Nombre",
          className: "medium",
        },
        {
          field: "CorreoCuentasPorCobrar",
          header: "Correo",
          className: "medium",
        },
        {
          field: "TelefonoCuentasPorCobrar",
          header: "Teléfono",
          className: "medium",
        },
      ],
    },

    {
      headerName: "Banco Nacional",
      children: [
        { field: "NumeroCuentaBancaria" },
        {
          // TitularCuentaBancaria
          field: "TitularCuenta",
          header: "Titular",
          className: "colum-width-medium",
          body: (rowData) => rowData.TitularCuenta,
        },
        {
          // Banco
          field: "Banco",
          header: "Banco",
          className: "colum-width-medium",
          body: (rowData) => rowData.Banco,
        },
        {
          header: "Deducción ACH",
          field: "DeduccionACH",
          // className: "colum-width-medium",
          body: (rowData) => rowData.DeduccionACH,
          Format: "Checkbox",
        },
        {
          header: "Pagar Cheque",
          field: "PagarCheque",
          // className: "colum-width-medium",
          body: (rowData) => rowData.PagarCheque,
          Format: "Checkbox",
        },
        {
          // TipoCuenta
          field: "TipoCuenta",
          header: "Tipo Cuenta",
          className: "colum-width-medium",
          body: (rowData) => rowData.TipoCuenta,
        },
        {
          // CurrencyName
          field: "CurrencyName",
          header: "Moneda",
          className: "colum-width-small",
          body: (rowData) => (
            <span>
              {rowData.Banco
                ? currencies.find((x) => x.IdCurrency === rowData.IdCurrency)
                  ?.Currency
                : ""}
            </span>
          ),
          Format: "Template",
        },
      ],
    },

    {
      headerName: "Banco Internacional",
      children: [
        {
          headerName: "Banco Intermediario",
          children: [
            // INFORMACION BANCARIA INTERNACIONAL
            {
              // BancoIntermediarioNombre
              field: "BancoIntermediarioNombre",
              header: "Banco Intermediario",
              className: "colum-width-medium",
              body: (rowData) => rowData.BancoIntermediarioNombre,
            },
            {
              // BancoIntermediarioDireccion
              field: "BancoIntermediarioDireccion",
              header: "Dirección",
              className: "colum-width-large",
              body: (rowData) => rowData.BancoIntermediarioDireccion,
            },
            {
              // BancoIntermediarioSwift
              field: "BancoIntermediarioSwift",
              header: "Switf",
              className: "colum-width-small",
              body: (rowData) => rowData.BancoIntermediarioSwift,
            },
            {
              // BancoIntermediarioAbaBin
              field: "BancoIntermediarioAbaBin",
              header: "ABA / BIN",
              className: "colum-width-small",
              body: (rowData) => rowData.BancoIntermediarioAbaBin,
            },
          ],
        },
        {
          headerName: "Banco Beneficiario",
          children: [
            {
              // BancoBeneficiarioNombre
              field: "BancoBeneficiarioNombre",
              header: "Nombre",
              className: "colum-width-medium",
              body: (rowData) => rowData.BancoBeneficiarioNombre,
            },
            {
              // BancoBeneficiarioDireccion
              field: "BancoBeneficiarioDireccion",
              header: "Dirección",
              className: "colum-width-largue",
              body: (rowData) => rowData.BancoBeneficiarioDireccion,
            },
            {
              // BancoBeneficiarioSwift
              field: "BancoBeneficiarioSwift",
              header: "Swift",
              className: "colum-width-small",
              body: (rowData) => rowData.BancoBeneficiarioSwift,
            },
            {
              // BancoBeneficiarioAbaBin
              field: "BancoBeneficiarioAbaBin",
              header: "ABA / BIN",
              className: "colum-width-small",
              body: (rowData) => rowData.BancoBeneficiarioAbaBin,
            },
            {
              // BancoBeneficiarioNombreBeneficiario
              field: "BancoBeneficiarioNombreBeneficiario",
              header: "Beneficiario",
              className: "colum-width-small",
              body: (rowData) => rowData.BancoBeneficiarioNombreBeneficiario,
            },
            {
              // BancoBeneficiarioCuenta
              field: "BancoBeneficiarioCuenta",
              header: "Cuenta",
              className: "colum-width-medium",
              body: (rowData) => rowData.BancoBeneficiarioCuenta,
            },
          ],
        },
        {
          // CurrencyName
          field: "CurrencyInternacional",
          header: "Moneda",
          className: "colum-width-small",
          body: (rowData) => (
            <span>
              {rowData.BancoBeneficiarioSwift
                ? currencies.find((x) => x.IdCurrency === rowData.IdCurrency)
                  ?.Currency
                : ""}
            </span>
          ),
          Format: "Template",
        },
      ],
    },
    {
      headerName: "Referencias Comerciales",
      children: [
        {
          headerName: "Referencia 1",
          children: [
            // REFERENCIAS COMERCIALES
            {
              // ref1Nombre
              field: "ref1Nombre",
              header: "Nombre",
              className: "colum-width-medium",
              body: (rowData) => rowData.ref1Nombre,
            },
            {
              // ref1Telefono
              field: "ref1Telefono",
              header: "Teléfono",
              className: "colum-width-small",
              body: (rowData) => rowData.ref1Telefono,
            },
            {
              // ref1Correo
              field: "ref1Correo",
              header: "Correo",
              className: "colum-width-medium",
              body: (rowData) => rowData.ref1Correo,
            },
          ],
        },
        {
          headerName: "Referencia 2",
          children: [
            {
              // ref2Nombre
              field: "ref2Nombre",
              header: "Nombre",
              className: "colum-width-medium",
              body: (rowData) => rowData.ref2Nombre,
            },
            {
              // ref2Telefono
              field: "ref2Telefono",
              header: "Teléfono",
              className: "colum-width-small",
              body: (rowData) => rowData.ref2Telefono,
            },
            {
              // ref2Correo
              field: "ref2Correo",
              header: "Correo",
              className: "colum-width-medium",
              body: (rowData) => rowData.ref2Correo,
            },
          ],
        },
      ],
    },
    {
      headerName: "Información Financiera",
      children: [
        {
          header: "Moneda",
          handerEn: "",
          field: "MonedaFin",
          className: "small",
        },

        {
          header: "Activos Corrientes",
          handerEn: "",
          field: "ActivosCorrientes",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Total Activos",
          handerEn: "",
          field: "TotalActivos",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Pasivos Corrientes",
          handerEn: "",
          field: "PasivosCorrientes",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Total Pasivos",
          handerEn: "",
          field: "TotalPasivos",
          className: "medium",
          Format: "Currency",
        },
      ],
    },
    {
      headerName: "Zona Libre",
      children: [
        // ZONA LIBRE
        {
          header: "Zona Libre",
          field: "ZonaLibre",
          className: "colum-width-medium",
          body: (rowData) => rowData.ZonaLibre,
          Format: "Checkbox",
        },
        {
          // NombreZonaLibre
          field: "NombreZonaLibre",
          header: "Nombre",
          className: "colum-width-medium",
          body: (rowData) => rowData.NombreZonaLibre,
        },
        {
          // DireccionZonaLibre
          field: "DireccionZonaLibre",
          header: "Dirección",
          className: "colum-width-XXlarge",
          body: (rowData) => rowData.DireccionZonaLibre,
        },
      ],
    },
    // ARCHIVOS
    {
      // BIC
      field: "BIC",
      header: "BIC",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload("getBICFile", "BIC", rowData.IdCustomer, rowData.BICName),
      Format: "Template",
    },
    {
      // BIC
      field: "Factura",
      header: "Factura",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getFacturaFile",
          "BIC",
          rowData.IdCustomer,
          rowData.FacturaName
        ),
      Format: "Template",
    },
    {
      // PermisoOperaciones
      field: "PermisoOperaciones",
      header: "Permiso Operaciones",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getPermisoOperacionesFile",
          "Permiso Operaciones",
          rowData.IdCustomer,
          rowData.PermisoOperacionesName
        ),
      Format: "Template",
    },
    {
      // ConstPagosCuenta
      field: "ConstPagosCuenta",
      header: "Constancia Pagos Cuenta",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getConstanciaPagosFile",
          "Constancia Pagos Cuenta",
          rowData.IdCustomer,
          rowData.ConstPagosName
        ),
      Format: "Template",
    },
    {
      // RegistroExonerado
      field: "RegistroExonerado",
      header: "Registro Exonerado",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getRegistroExoneradoFile",
          "Registro Exonerado",
          rowData.IdCustomer,
          rowData.RegistroExoneradoName
        ),
      Format: "Template",
    },
    {
      // EscrituraConstitucion
      field: "EscrituraConstitucion",
      header: "Escritura Constitución",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getEscrituraConstitucionFile",
          "Escritura Constitución",
          rowData.IdCustomer,
          rowData.EscrituraConstitucionName
        ),
      Format: "Template",
    },
    {
      field: 'IdCustomer',
      header: 'Acciones',
      headerEn: '',
      tooltip: 'Acciones',
      Format: 'Botones',
      alignFrozen: "right",
      Botones: [
        {
          icon: 'ri-lock-unlock-line',
          tooltip: '',
          onClick: (data) => {
            setProveedorEditar(data);
            setShowDialogPassword(true);
          },
          className: '',
          disabled: () =>  IsVarios || (userAuth?.Accesos ? userAuth?.Accesos.split(',').includes('1030') === false : false),
          hidden: () => IsVarios || (userAuth?.Accesos ? userAuth?.Accesos.split(',').includes('1030') === false : false),
        },
        {
          icon: 'pi pi-pencil',
          tooltip: '',
          onClick: (data) => openNew(data.IdCustomer),
          className: '',
          disabled: () => IsVarios || userAuth.IdRol !== 1,
          hidden: () => IsVarios || userAuth.IdRol !== 1,
        },
        {
          icon: 'ri ri-folder-user-line',
          tooltip: 'CAI',
          onClick: (data) => openDialogCAI(data.IdCustomer),
          className: ''
        },
        {
          icon: 'pi pi-envelope',
          tooltip: 'Enviar correo de inscripción',
          onClick: async (data) => {
            setShowDialog(true);
            setProveedorMail(data);
            setCorreoAEviar(data?.Email === " " ? [] : [data?.Email]);
            const enlaceT = await getEnlaceInscripcion(data.IdCustomer, userAuth?.idUser, Finanzas);
            setEnlace({
              enlace: enlaceT[0],
              Email: correoAEviar,
              CustomerName: data?.CustomerName,
            });
          },
          className: '',
          // disabled: validarDeshabilitarEdicion,
        },
        {
          icon: 'pi pi-file-edit',
          tooltip: 'Solicitar edición',
          onClick: (rowData) => {
            openDialogSolicitudEdicion(rowData);
          },
        }
      ]
    },

    {
      // EnviarCorreoInscripcion
      field: "Acciones",
      header: "",
      className: "small",
      body: (rowData) => botonEnviarCorreo(rowData),
      frozen: "frozen",
      alignFrozen: "right",
      Format: "Template",
      filter: false
    },
  ];

  const table = {
    Columns: columnBands,
    Data: proveedoresFilter,
    key: "IdCustomer",
    scrollHeight: "100%",
    selected: selected,
    setSelected: setSelected

  };

  const habilitarEdicion = async () => {
    setLoading(true);
    let data = proveedorEditar;


    const user = {
      Password: await encryptor(password),
      idUser: await encryptor(userAuth.idUser + '')
    }


      const index = Proveedores.findIndex(detail => detail.IdCustomer === data.IdCustomer);
      let newDetail = [...Proveedores];
      newDetail[index].IdStatus = 3722;
      let result = await CambiarEstadoRevision({ IdStatus: 3722, IdCustomer: data.IdCustomer, IdUser: userAuth?.idUser, user: user })
      console.log(result);
      
      toastShow(toast, result[0]?.ERROR ? "error" : "success", result[0]?.MSJ);
      setProveedores(newDetail);
      getInfo();

    hideDialogPassword();
    setLoading(false);
  }

  const hideDialogPassword = () => {
    setShowDialogPassword(false);
    setProveedorEditar(null);
    setPassword('');
  }

  const getInfo = async () => {
    setLoading(true);
    // const tempo = await getCompanyVarios();
    let tempo
    if (IsVarios) {
      tempo = await getCompanyVarios();
    } else {
      tempo = await getCompanyCompras();
    }
    const monedas = await getCurrencyIPS();
    const tempoEstados = await getEstadosClientesIPS()
    setEstados(tempoEstados);
    const tempoEstadosRevision = await getEstadosCategoryIPS("Revision Proveedor");
    setEstadosRevision(tempoEstadosRevision);
    setCurrencies(monedas);
    setProveedores(tempo);
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
    window.document.title = "PPF • Proveedores";
  }, []);

  useEffect(() => {
    if(mostarActivos){
      setProveedoresFilter(Proveedores.filter(e => e.IdStatus === 1))
    }else{
      setProveedoresFilter(Proveedores)
    }
  }, [Proveedores, mostarActivos])


  return (
    <div
      id="ListProveedores"
      style={{ width: '99%' }}
    >
      <Toast position="bottom-right" ref={toast} />
      <Loading loading={loading} querySelector="#ListProveedores" />


      {showDialog && (
        <ReusableDialog
          visible={showDialog}
          onHide={() => {
            setShowDialog(false);
            setProveedorMail(undefined)
          }}
          header={`Enviar Correo a proveedor  ${enlace?.CustomerName}`}
          ejecutar={() => { EnviarCorreoInscripcion() }}
          Id={proveedorMail?.IdCustomer}
          enlace={`${process.env.REACT_APP_PUBLIC_URL}/inscripcionProveedor/${idioma}/${enlace?.enlace}`}
          correoAEnviar={correoAEviar}
          setCorreoAEnviar={setCorreoAEviar}
          idioma={idioma}
          setIdioma={setIdioma}
          setLoading={setLoading}
          // loading={loadingCorreo}

        />
      )}

      <Card
        titulo={
          <div className='d-flex gap'>

            <Button onClick={getInfo} icon="pi pi-refresh" loading={loading} style={{ height: 35 }} />
            <Button icon='pi pi-plus' onClick={() => openNew(0)} style={{ height: 35 }} />
            {/* boton mostr */}
            <Button label={mostarActivos ? "Mostrar inactivos" : "Mostrar Activos" } onClick={e => setMostarActivos(!mostarActivos)} />
            
          </div>
        }

        contenido={<div className='pt-3' style={{ height: '80vh' }} id="ListadoProveedores">
          <AgGrid table={table} />
        </div>}
      />

      {/* <Card
        titulo={title}
        style={{ width: '99%', height: '90vh' }}
        contenido={
          <div
            className="BandedColumns"
            style={{ width: '99%', height: '90vh' }}
          >
            <AgGrid table={table} />
          </div>
        }
      /> */}

      <ModalProveedores
        proveedoresDialog={proveedoresDialog}
        hideDialog={hideDialog}
        IdCustomer={IdCustomer}
        getInfo={getInfo}
      />

      <ModalProveedorCAI
        proveedoresCAIDialog={dialogCAI}
        setProveedoresCAIDialog={setDialogCAI}
        hideDialog={hideDialog}
        IdProveedor={IdCustomer}
      />


      {showDialogFormato && (
        <FormatoInscripcionPDF
          setShowDialogFormato={setShowDialogFormato}
          showDialogFormato={showDialogFormato}
          selectedFormato={selectedFormato}
          setSelectedFormato={setSelectedFormato}
          Language={lenguaje}
        />
      )}

      <Dialog
        visible={showDialogPassword}
        onHide={() => hideDialogPassword()}
        header="Habilitar edición de enlace de inscripción"
        style={{ width: '500px' }}
      >
        <h4>{proveedorEditar?.CustomerName}</h4>
        <div className='d-flex flex-row' style={{ marginTop: 2 }}>
          <span className="p-inputgroup-addon">
            <i className="pi pi-lock"></i>
          </span>
          <Password
            id="password"
            name="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && habilitarEdicion(e.target.value)}
            toggleMask={true}
            feedback={false}
            autoComplete="new-password"
          />
        </div>
        <div className="d-flex" style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Cancelar"
            onClick={() => hideDialogPassword()}
            style={{ marginTop: 10, marginRight: 10 }}
            className="p-button-secondary"
          />
          <Button
            label="Habilitar"
            onClick={() => habilitarEdicion(password)}
            style={{ marginTop: 10 }}
            disabled={password.length === 0}
          />

        </div>

      </Dialog>
      <ModalSolicitudEdicionProveedor
        visible={dialogSolicitudEdicion}
        onHide={() => setDialogSolicitudEdicion(false)}
        IdProveedor={IdCustomer}
        IdStatus={proveedorSolicitudEdicion?.IdStatus}
        proveedorData={proveedorSolicitudEdicion}
        onSuccess={() => getInfo()}
        toast={toast}
      />
      <ConfirmDialog />
    </div>
  );
};

export default ProveedoresScreen;
